import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-inq-form',
	imports: [CommonModule, FormsModule],
  providers: [DatePipe],
  templateUrl: './inq-form.component.html',
  styleUrl: './inq-form.component.scss',
})
export class InqFormComponent {
  @Input() user: any;
  @Input() action: any;
  
  totalRec: any = null;
  datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  localeDate: any = new Date().toLocaleDateString('en-IN');
  districts: any = null;

  base = 'inquiries';		// important for API calls
  loading = false;
  headers: any = null;
	isReadonly = true;
	orgs: any = [];
  users: any = [];
  rec_con_users: any = [];

  frmDataX: any = {};
  frmData: any = {
    id: null,
    code: '',
    iname: '', 
    gender: '', 
    dob: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
    father: '', 
    mother: '', 
    guardian: '', 
    mobile_no: '0', 
    alt_phone: '0', 
    email_id: '@', 
    address: '', 
    city: '', 
    state: '', 
    pincode: '', 
    country: 'India', 
    pass_from: '', 
    pass_year: '0', 
    pass_class: '', 
    pass_marks: '0', 
    new_class: '', 
    new_session: '0', 
    added_by: '1', 
    inq_source: '', 
    inq_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
    inq_status: '',
    inq_notes: ''
  }
  customCode: any = '';

  constructor(public dataService: DataService) {
    //
  }

  async ngOnInit() {
		this.loading = true;
    await this.dataService.getAllRecords('users').then((res: any) => {
      if(res && res.length) {
        this.users = res;
        for(let i=0; i<res.length; i++) {
          this.users[i].user_role = this.dataService.str2json(this.users[i].user_role);
        }
      }
      
      this.usersRecCon();
      this.loading = false;
    });

    this.loading = true;
    await this.dataService.getAllRecords(this.base).then((res: any) => {
      let inqData: any = res;
      const prefix: any = this.dataService.settings.id_prefix[2];
      let lastCodeVal: number = parseInt(inqData[0].code.substr(-5));

      if(lastCodeVal > 0) {
        this.customCode = prefix.id_inq + String(lastCodeVal + 1).padStart(5, '0');
      } else {
        this.customCode = prefix.id_inq + prefix.start_no.padStart(5, '0');
      }
      this.loading = false;
    });

		this.loading = true;
    await this.dataService.getAllRecords('organizations').then((res: any) => {
      this.orgs = res;
      this.loading = false;
    });

    // Listen to changes continuously
    await this.dataService.outerAction.subscribe((value: any) => {
      if(value) {
        if(value.component != 'inquiry') return;

        this.action = value.action;

        if(value.data) {
          this.frmData = Object.assign({}, value.data);
          this.frmData.dob = this.frmData.dob.substr(0,10);
          this.frmData.inq_date = this.frmData.inq_date.substr(0,10);

          if(this.frmData.state) {
            this.districts = this.dataService.getDist(this.frmData.state);
          }
        } else {
          this.resetForm();
        }
        this.dataService.updateOuterAction(null);
      }
    });
	}

  ngOnChanges() {
    if(this.action) {
      switch(this.action) {
        case 'addnew':
          this.isReadonly = false;
          // this.frmDataSet();
          this.resetForm();
          break;
        case 'modify':
          this.isReadonly = false;
          // this.frmDataSet();
          break;
        case 'save':
          this.doSave();
          this.isReadonly = true;
          break;
        case 'update':
          this.doUpdate();
          this.isReadonly = true;
          break;
        case 'cancel':
          this.isReadonly = true;
          this.resetForm();
          break;
        default:
          break;
      }

      this.action = '';
    }
  }

  usersRecCon() {
    this.rec_con_users = this.users.filter((obj: any) => {
      return obj.user_role[0].code == 'rec' || obj.user_role[0].code == 'con';
    });
  }

  // frmDataSet() {
  //   if(this.frmData) {
  //     this.frmDataX = Object.assign({}, this.frmData);
  //   } else {
  //     this.frmDataX = {};
  //   }
  // }

	resetForm() {
		this.frmData = {
      id: null, 
      code: '',
      iname: '', 
      gender: '', 
      dob: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      father: '', 
      mother: '', 
      guardian: '', 
      mobile_no: '0', 
      alt_phone: '0', 
      email_id: '@', 
      address: '', 
      city: '', 
      state: '', 
      pincode: '', 
      country: 'India', 
      pass_from: '', 
      pass_year: '0', 
      pass_class: '', 
      pass_marks: '0', 
      new_class: '', 
      new_session: '0', 
      added_by: '1', 
      inq_source: '', 
      inq_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      inq_status: '',
      inq_notes: ''
		};
	}

  doSave() {
    this.loading = true;
    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response) => {
        // set activity log details
				this.dataService.setActivityLog('create', 'inquery', 'New inquery "'+this.frmData.iname+'" added.');
        // console.log('Response received in component:', response);
        this.loading = false;
        this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    this.loading = true;
		const myid = this.frmData.id;
		delete this.frmData.id;

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // set activity log details
				this.dataService.setActivityLog('update', 'inquery', 'Update inquery "'+this.frmData.iname+'" details.');
        // console.log('Response received in component:', response);
        this.loading = false;
        this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }
}
